var _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoDateNoInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.4674 4H4.53261C3.68617 4 3 4.77769 3 5.73701V38.263C3 39.2223 3.68617 40 4.53261 40H37.4674C38.3138 40 39 39.2223 39 38.263V5.73701C39 4.77769 38.3138 4 37.4674 4Z",
    stroke: "#FFD4A3",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 1V8",
    stroke: "#FFD4A3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 1V8",
    stroke: "#FFD4A3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 14H39",
    stroke: "#FFD4A3",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 39C36.4036 39 42 33.4036 42 26.5C42 19.5964 36.4036 14 29.5 14C22.5964 14 17 19.5964 17 26.5C17 33.4036 22.5964 39 29.5 39Z",
    fill: "#FF5959"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9752 30.736L32 17H27L27.9938 30.736H30.9752ZM31.8137 37V32.8427H27.1863V37H31.8137Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDateNoInfo);
export default __webpack_public_path__ + "static/media/ico_date_no_info.ecb57433a88e003cef7b478d943d02f5.svg";
export { ForwardRef as ReactComponent };